import { ExtractPropTypes, PropType } from 'vue'

export interface CascaderOption {
  value: string | number
  label: string
  children?: CascaderOption[]
  disabled?: boolean
  leaf?: boolean
  [key: string]: any
}

export type CascaderValue = string | number | (string | number)[]

export const cascaderProps = {
  modelValue: {
    type: [String, Number, Array] as PropType<CascaderValue>,
    default: () => []
  },
  options: {
    type: Array as PropType<CascaderOption[]>,
    default: () => []
  },
  props: {
    type: Object as PropType<{
      expandTrigger?: 'click' | 'hover'
      multiple?: boolean
      checkStrictly?: boolean
      emitPath?: boolean
      lazy?: boolean
      lazyLoad?: (node: CascaderOption, resolve: (children: CascaderOption[]) => void) => void
      value?: string
      label?: string
      children?: string
      disabled?: string
      leaf?: string
    }>,
    default: () => ({
      expandTrigger: 'click',
      multiple: false,
      checkStrictly: false,
      emitPath: true,
      value: 'value',
      label: 'label',
      children: 'children',
      disabled: 'disabled',
      leaf: 'leaf'
    })
  },
  placeholder: {
    type: String,
    default: '请选择'
  },
  disabled: Boolean,
  clearable: Boolean,
  filterable: Boolean,
  filterMethod: {
    type: Function as PropType<(node: CascaderOption, keyword: string) => boolean>,
    default: (node: CascaderOption, keyword: string) => {
      return node.label.includes(keyword)
    }
  },
  size: {
    type: String as PropType<'small' | 'medium' | 'large'>,
    default: 'medium'
  },
  showAllLevels: {
    type: Boolean,
    default: true
  },
  collapseTags: Boolean,
  separator: {
    type: String,
    default: ' / '
  }
} as const

export type CascaderProps = Partial<ExtractPropTypes<typeof cascaderProps>>

export const cascaderEmits = {
  'update:modelValue': (value: CascaderValue) => true,
  'change': (value: CascaderValue) => true,
  'expand-change': (value: CascaderOption[]) => true,
  'blur': (e: FocusEvent) => e instanceof FocusEvent,
  'focus': (e: FocusEvent) => e instanceof FocusEvent,
  'visible-change': (visible: boolean) => typeof visible === 'boolean',
  'remove-tag': (value: CascaderValue) => true
}

export type CascaderEmits = typeof cascaderEmits